interface DiscoveryAnalytics {
    track: (event: string, data: Record<string, string | number>) => void | Promise<unknown>;
}

export function initializeDiscovery(root: ParentNode = document): void {
    root.querySelectorAll<HTMLAnchorElement>('[data-discovery-card]').forEach((card) => {
        if (card.dataset.discoveryTracked) return;
        card.dataset.discoveryTracked = 'true';
        const track = (event: MouseEvent): void => {
            if (event.type === 'auxclick' && event.button !== 1) return;
            const analytics = (window as Window & { umami?: DiscoveryAnalytics }).umami;
            if (!analytics) return;
            try {
                const result = analytics.track('discovery-card-click', {
                    section: card.dataset.section ?? '',
                    item_type: card.dataset.itemType ?? '',
                    item_id: card.dataset.itemId ?? '',
                    position: Number(card.dataset.position),
                });
                if (result instanceof Promise) void result.catch(() => undefined);
            } catch {
                // Analytics must never interrupt navigation.
            }
        };
        card.addEventListener('click', track);
        card.addEventListener('auxclick', track);
    });
}
